import { ContainerModule } from 'inversify';
import { DomainConfig } from '@framework/config/DI/domainModule/DomainConfig';
import { DataroomDomainConfig } from '../domain/DataroomDomainConfig';
import { TYPES } from '@framework/config/DI/types';

export const domainModule = new ContainerModule(({ bind }) => {
  bind<DomainConfig>(TYPES.DomainConfig).to(DataroomDomainConfig).inSingletonScope();
});
